module.exports = new Promise((resolve, reject) => {
  const remoteName = "@coremind/home-media-optimizer-ui";
  const baseUrl = window.__COREMIND_FEDERATED_BASE_URL__ || '/federated';
  const urlMap = window.__COREMIND_FEDERATED_PACKS__ || {};
  const cacheBust = window.__COREMIND_FEDERATED_CACHE_BUST__ || '';
  const channel = String(window.__COREMIND_FEDERATED_CHANNEL__ || '').trim();
  const debug = Boolean(window.__COREMIND_FEDERATED_DEBUG__);
  const log = (...args) => { if (debug) console.log('[federation]', ...args); };
  const warn = (...args) => { if (debug) console.warn('[federation]', ...args); };
  const normalizedBase = baseUrl.replace(/\/$/, '');
  const isLocalBase = normalizedBase.startsWith('/');
  const legacyPath = normalizedBase + '/' + remoteName.replace(/\//g, '__') + '/remoteEntry.js';
  const remoteScopePath = remoteName.replace('@', '%40');
  const s3Path = channel
    ? normalizedBase + '/' + remoteScopePath + '/channels/' + encodeURIComponent(channel) + '/remoteEntry.js'
    : normalizedBase + '/' + remoteScopePath + '/latest/remoteEntry.js';
  const remoteUrl = urlMap[remoteName] || (isLocalBase ? legacyPath : s3Path);
  const remoteUrlWithCache = cacheBust ? (remoteUrl + (remoteUrl.includes('?') ? '&' : '?') + 'v=' + encodeURIComponent(cacheBust)) : remoteUrl;
  const initSharing = (typeof __webpack_init_sharing__ === 'function')
    ? __webpack_init_sharing__('default')
    : Promise.resolve();
  initSharing.then(() => {
    const shareScope = (typeof __webpack_share_scopes__ !== 'undefined') ? __webpack_share_scopes__.default : undefined;
    log('init sharing', { remoteName, remoteUrl: remoteUrlWithCache });
  const existing = document.querySelector('script[data-remote="' + remoteName + '"]');
  if (existing) {
    log('script already present', { remoteName, src: existing.src });
    return resolve({
      get: (request) => {
        log('container.get', { remoteName, request });
        return window[remoteName].get(request);
      },
      init: (arg) => {
        try { return window[remoteName].init(arg); } catch (e) { return undefined; }
      }
    });
  }
  const script = document.createElement('script');
  script.src = remoteUrlWithCache;
  script.type = 'text/javascript';
  script.async = true;
  script.dataset.remote = remoteName;
  script.onload = () => {
    const container = window[remoteName];
    if (!container) {
      warn('missing container', { remoteName });
      return reject(new Error('Missing remote container for ' + remoteName));
    }
    log('script loaded', { remoteName, src: remoteUrlWithCache });
    resolve({
      get: (request) => {
        log('container.get', { remoteName, request });
        return container.get(request);
      },
      init: (arg) => {
        try { return container.init(arg || shareScope); } catch (e) { return undefined; }
      }
    });
  };
  script.onerror = () => {
    warn('script error', { remoteName, src: remoteUrlWithCache });
    if (!isLocalBase && remoteUrl === s3Path) {
      const legacyUrl = legacyPath;
      const legacyUrlWithCache = cacheBust ? (legacyUrl + (legacyUrl.includes('?') ? '&' : '?') + 'v=' + encodeURIComponent(cacheBust)) : legacyUrl;
      warn('retrying legacy federated path', { remoteName, src: legacyUrlWithCache });
      const fallback = document.createElement('script');
      fallback.src = legacyUrlWithCache;
      fallback.type = 'text/javascript';
      fallback.async = true;
      fallback.dataset.remote = remoteName;
      fallback.onload = script.onload;
      fallback.onerror = () => {
        warn('legacy script error', { remoteName, src: legacyUrlWithCache });
        reject(new Error('Failed to load ' + remoteName + ' from ' + remoteUrl + ' or ' + legacyUrl));
      };
      document.head.appendChild(fallback);
      return;
    }
    reject(new Error('Failed to load ' + remoteName + ' from ' + remoteUrl));
  };
  log('injecting script', { remoteName, src: remoteUrlWithCache });
  document.head.appendChild(script);
  });
});